export default __webpack_public_path__ + "static/media/us_flag_cropped.c3e5caf3.jpg";